/* eslint-disable @typescript-eslint/promise-function-async */

import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MsalGuard, MsalRedirectComponent } from "@azure/msal-angular";
import { AppLayoutComponent } from "src/app/layout/app.layout.component";
import { DocumentsSpaceDetailsComponent } from "src/app/modules/documents-space/documents-space-details/documents-space-details.component";
import { DocumentsSpaceListComponent } from "src/app/modules/documents-space/documents-space-list/documents-space-list.component";
import { PageNotFoundComponent } from "src/app/modules/error-page/components/404/page-not-found.component";

export const routes: Routes = [
  {
    path: "auth",
    component: MsalRedirectComponent,
  },
  {
    path: "",
    redirectTo: "accueil",
    pathMatch: "full",
  },
  {
    path: "",
    component: AppLayoutComponent,
    canActivate: [MsalGuard],
    canActivateChild: [MsalGuard],
    children: [
      {
        data: {
          title: "Accueil",
        },
        path: "accueil",
        loadChildren: () => import("./modules/home-page/home-page.module").then((m) => m.HomePageModule),
      },
      {
        path: "dashboard",
        loadChildren: () => import("./modules/dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "articles",
        loadChildren: () => import("./modules/articles-cue/articles-cue.module").then((m) => m.ArticlesCueModule),
      },
      {
        path: "news",
        loadChildren: () => import("./modules/agency-news/agency-news.module").then((m) => m.AgencyNewsModule),
      },
      {
        path: "audiovisual-media",
        loadChildren: () =>
          import("./modules/audiovisual-media/audiovisual-media.module").then((m) => m.AudiovisualMediaModule),
      },
      {
        path: "users",
        loadChildren: () => import("./modules/users/users.module").then((m) => m.UsersModule),
      },
      {
        path: "translation",
        loadChildren: () => import("./modules/translation/translation.module").then((m) => m.TranslationModule),
      },
      {
        path: "radio",
        loadChildren: () => import("./modules/speech2text/speech2text.module").then((m) => m.Speech2textModule),
        data: {
          title: "RTS.ch Audio & Podcast",
          speech2TextType: "AUDIO",
        },
      },
      {
        path: "play-rts",
        loadChildren: () => import("./modules/speech2text/speech2text.module").then((m) => m.Speech2textModule),
        data: {
          title: "Play RTS",
          speech2TextType: "VIDEO",
        },
      },
      {
        path: "entities",
        loadChildren: () => import("./modules/entity/entity.module").then((m) => m.EntityModule),
      },
      {
        path: "instagram",
        loadChildren: () => import("./modules/instagram/instagram.module").then((m) => m.InstagramModule),
      },
      {
        path: "transcriptions",
        loadChildren: () => import("./modules/audio/audio.module").then((m) => m.AudioModule),
      },
      {
        path: "prompts",
        loadChildren: () => import("./modules/prompts/prompts.module").then((m) => m.PromptsModule),
      },
      {
        path: "website-crawling-assistant",
        loadChildren: () =>
          import("./modules/website-crawling-assistant/website-crawling-assistant.module").then(
            (m) => m.WebsiteCrawlingAssistantModule,
          ),
      },
      {
        path: "documents",
        loadChildren: () => import("./modules/document/document").then((m) => m.Document),
      },
      {
        path: "documents-spaces",
        component: DocumentsSpaceListComponent,
        title: "Documents Spaces",
      },
      { path: "documents-spaces/:id", component: DocumentsSpaceDetailsComponent, title: "Documents Space Details" },
    ],
  },
  {
    path: "**",
    component: PageNotFoundComponent,
    data: { title: "404 Page Not Found" },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
